<template>
  <b-container class="mt-5">
    <div v-if="eula">
      <h1 class="page-title">
        {{ eula.title }}
      </h1>
      <!-- eslint-disable-next-line -->
      <div v-html="eula.content" />
    </div>
    <Loader v-if="contentStatus === 'loading'" />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {EULA_REQUEST} from "@/store/constant";
import Loader from "@/components/Loader";

export default {
  name: 'Eula',
  components: {Loader},
  computed: {
    ...mapGetters(['eula', 'contentStatus'])
  },
  mounted() {
    this.getPrivacy();
  },
  methods: {
    getPrivacy() {
      this.$store.dispatch(EULA_REQUEST);
    }
  }
}
</script>
